<template>
  <div class="risk-disclosure-box">
    <bCardHeader :param="param"></bCardHeader>
    <div class="disclosure-box">
      <div class="top-title">{{$t('fund.disclosure')}}</div>
      <div class="content">
        <div class="itme"
             v-for="(item,index) in contentList"
             :key="index">
          <div class="item-title">
            {{item}}
          </div>
          <div v-if="!isEnglish" class="item-en">{{usContent[index]}}</div>
        </div>
      </div>
      <div class="agree-info">
        <div class="top-agree">
          <el-checkbox v-model="checked">{{$t('fund.agreeText')}}
        </el-checkbox>
        <span class="protocol"
              @click.stop="toLink('fundRiskWarning')">「{{$t('fund.riskProtocol')}}」</span>
         <span>{{$t('fund.and')}}</span>
        <span class="protocol"
              @click.stop="toLink('fundSales')">「{{$t('fund.protocol')}}」</span>
        </div>
        <div class="top-agree">
        <el-checkbox v-model="checked2">{{$t('fund.infoSame')}}
        </el-checkbox>
      </div>
        <div v-if="isMainland" class="top-agree">
          <el-checkbox v-model="checked4">{{$t('applyTradeAccount.complianceDeclarationTextOne')}}</el-checkbox>
          <a :href="$t('applyTradeAccount.declarationLink')" target="_blank">
            <span class="protocol">{{$t('applyTradeAccount.declarationLinkContent')}}</span>
          </a>
          <span>{{$t('applyTradeAccount.declarationLastText')}}</span>
        </div>
      </div>
      <div class="btn-box"
           @click="sureOpenHandle">{{$t('fund.sureBtnText')}}</div>
    </div>
  </div>
</template>

<script>
import api from '@/api/v2/trade'
import { getAgreementContent } from '@/api/v2/deposit.js'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      param: {
        title: 'other_account',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'other_account'
          }
        ]
      },
      contentList: this.$t('fund.warningList'),
      usContent: [
        `Investors should not base their investment decisions on the content of this website and app alone. Investors should refer to the fund's offering documents and read carefully the summary of the key features and risks specific to this fund stated in the fund factsheet prepared by the relevant fund house, before making any investment decision. Fund offering documents can be found in the Eddid One App, and relevant fund house website.`,
        `Unit Trusts are investment products and some may involve derivatives. The investment decision is yours but you should not invest in the Unit Trusts unless the intermediary who sells it to you has explained to you that the product is suitable for you having regard to your financial situation, investment experience and investment objectives.`,
        `Unit Trusts are NOT equivalent to time deposits.`,
        `Investment involves risks. Past performance is no guide to future performance of the funds. Value of the investments and the income/dividend generated can fluctuate and is not guaranteed.`,
        `In worst case scenario, the value of the fund may be worth substantially less than the original amount you have invested (and in an extreme case could be worth nothing).`,
        `The funds' investment may involve substantial market, currency, volatility, liquidity, regulatory and political risks.`,
        `If the funds invest in emerging markets, a single market or a limited number of geographical market(s) or industry sector(s) or smaller cap companies, the funds will be subject to higher degree of risk and are usually more sensitive to price movements.`,
        `If the funds invest in derivatives, additional risks will be involved, and the funds may be subject to higher volatility.`,
        `If the investment is denominated in foreign currency, any conversion to Hong Kong dollars is indicative and provided for your reference only. Total investment value will be displayed in HKD, and individual fund holding value will be displayed in its denominated currency.`
      ],
      checked: false,
      checked2: false,
      checked4: false,
      protocolLink: '',
      riskLink: '',
      linkMap: {
        fundSales: 'protocolLink',
        fundRiskWarning: 'riskLink'
      }
    }
  },
  created() {
    this.getAgreementContentFun('fundSales')
    this.getAgreementContentFun('fundRiskWarning')
  },
  computed: {
    ...mapState(['selectLang', 'theme', 'accountNumber', 'klineTheme', 'userInfo']),

    isEnglish() {
      return this.selectLang === 'en'
    },
    isMainland() {
      return this.userInfo?.isMainland === 'Y' && this.userInfo?.mainlandComplianceAgreed === 'N'
    }
  },
  methods: {
    async sureOpenHandle() {
      if (!this.checked || !this.checked2) {
        return this.$message.error(this.$t('fund.warntextAgree'))
      }
      if (this.isMainland && !this.checked4) {
        return this.$message.error(this.$t('fund.warntextAgree'))
      }
      let params = {
        agreement: this.checked,
        infoIsSame: true,
        submitSource: 'CP_WEB',
        tradeAccountType: 'FUND_CASH'
      }
      let res = await api.commitTradeAccount(params)
      if (res && res.code === 200) {
        this.$router.replace({
          path: '/result'
        })
      }
    },
    // 获取协议地址
    async getAgreementContentFun(type) {
      let params = {
        platform: 'H5',
        type
      }
      let res = await getAgreementContent(params)
      if (res.code === 200) {
        this[this.linkMap[type]] = res.data && res.data.path
        // this.protocolLink = res.data && res.data.path
        // this.riskLink = res.data && res.data.path
      }
    },
    toLink(type) {
      window.open(this[this.linkMap[type]])
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-disclosure-box {
  .disclosure-box {
    background: #ffffff;
    box-shadow: 0px 3px 7px 0px rgba(179, 179, 179, 0.5);
    border-radius: 5px;
    min-height: 600px;
    padding: 14px 30px 30px;
    .top-title {
      font-size: 18px;
      font-weight: 600;
      color: #182a54;
      line-height: 30px;
      padding-bottom: 16px;
      border-bottom: 3px solid #ebebeb;
      margin-bottom: 19px;
    }
    .content {
      .itme {
        position: relative;
        margin-bottom: 20px;
        &::before {
          content: '';
          top: 3px;
          left: 0;
          position: absolute;
          width: 4px;
          height: 15px;
          background: #fec000;
        }
      }
      .item-title {
        font-size: 15px;
        font-weight: 400;
        color: #24282d;
        line-height: 21px;
        margin-left: 10px;
        margin-bottom: 10px;
      }
      .item-en {
        background: #f9fbff;
        font-size: 14px;
        font-weight: 400;
        color: #868e9e;
        line-height: 20px;
        padding: 10px;
      }
    }
    .agree-info {
      margin-bottom: 30px;
      /deep/ .el-checkbox__label {
        font-size: 15px !important;
        font-weight: 500;
        color: #24282d;
        line-height: 20px;
        padding-left: 8px !important;
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        border-color: #fec000;
        background: #fec000;
      }
      .protocol {
        color: #fec000;
        cursor: pointer;
      }
      .top-agree{
        margin-bottom: 10px;
      }
    }
    .btn-box {
      width: fit-content;
      padding: 0 20px;
      height: 50px;
      font-size: 14px;
      background: #fec000;
      border-radius: 5px;
      font-weight: 600;
      color: #192b57;
      line-height: 50px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
